export default "__VITE_ASSET__Ch2yYGan__"